import { MissingTranslationHandler, MissingTranslationHandlerParams } from '@ngx-translate/core';
import { Injectable } from '@angular/core';

@Injectable()
export class CustomMissingTranslationHandler implements MissingTranslationHandler {

  handle(params: MissingTranslationHandlerParams) {
    
    // Handle missing translation logic here
    // For example, return a placeholder text like "[Missing translation]"
    console.log('Missing translation:', params);
    return `[Missing translation ${params.key}]`; // You can return the missing key wrapped with square brackets, or a fallback message
  }
}
